module.exports = __webpack_public_path__ + "static/media/Gandalf.65f5ba65.png";